import { type SvgProps, SvgWrapper } from '../utils';

export function LockFilledIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C13.5913 1 15.117 1.63259 16.2422 2.75781C17.3674 3.88303 18 5.4087 18 7V9.25H18.2227C19.7547 9.25028 20.7499 10.7135 20.75 12.1816V19.8184C20.7499 21.2865 19.7547 22.7497 18.2227 22.75H5.77734C4.24534 22.7497 3.25008 21.2865 3.25 19.8184V12.1816C3.25008 10.7135 4.24534 9.25028 5.77734 9.25H6V7C6 5.4087 6.63259 3.88303 7.75781 2.75781C8.88303 1.63259 10.4087 1 12 1ZM12 13.25C11.0335 13.25 10.25 14.0335 10.25 15C10.25 15.5943 10.5471 16.1183 11 16.4346V17.5C11 18.0523 11.4477 18.5 12 18.5C12.5523 18.5 13 18.0523 13 17.5V16.4346C13.4529 16.1183 13.75 15.5943 13.75 15C13.75 14.0335 12.9665 13.25 12 13.25ZM12 3C10.9391 3 9.92202 3.42173 9.17188 4.17188C8.42173 4.92202 8 5.93913 8 7V9.25H16V7C16 5.93913 15.5783 4.92202 14.8281 4.17188C14.078 3.42173 13.0609 3 12 3Z"
      />
    </SvgWrapper>
  );
}
